<template>
  <div>
    <div class="toprow">
      <div class="selection-item has-text-centered">
        <span id="variableSelect" class="selection is-size-7-mobile"><strong>Variables</strong> <em>({{varCountText}})</em></span>
        <app-router-button aria-labelledby="variableSelect" :to="{name: 'select_variables'}" :class="variableButtonClass" :height="buttonHeight">
          <span v-html="variableButtonText"></span>
        </app-router-button>
      </div>

      <div class="selection-item has-text-centered">
        <span id="placeSelect" class="selection is-size-7-mobile"><strong>Place</strong></span>
        <app-router-button aria-labelledby="placeSelect" :to="{name: 'place_search'}" class="button is-primary selection is-small-mobile" :height="buttonHeight">
          <span v-html="placeButtonText"></span>
        </app-router-button >
      </div>

      <div class="selection-item has-text-centered">
        <span id="sampleSelect" class="selection is-size-7-mobile"><strong>Time</strong> <em>({{sampleCountText}})</em></span>
        <app-router-button aria-labelledby="sampleSelect" :to="{name: 'sample_search'}" :class="sampleButtonClass" :height="buttonHeight">
          <span v-html="sampleButtonText"></span>
        </app-router-button >
      </div>
    </div>

    <div class="bottomrow has-text-centered">
      <span id="subpopSelect" class="selection is-size-7-mobile"><strong>Subpopulation</strong> <em>(optional)</em></span>
      <app-router-button aria-labelledby="subpopSelect" :to="{name: 'select_subpopulation'}" :class="subpopButtonClass" :height="buttonHeight">
        <span v-html="subpopButtonText"></span>
      </app-router-button>
    </div>
  </div>

</template>

<script>

  import { mapState } from 'pinia';
  import { useSelectionStore } from "../stores/selection";
  import AppRouterButton from "App/components/AppRouterButton";

  export default {
    computed: {
      ...mapState(useSelectionStore, [
        'selectedSamples',
        'selectedVariables',
        'selectedPlace',
        'selectedSubpopulations'
      ]),
      buttonHeight() {
        return "2.5em";
      },
      sampleButtonText() {
        if (this.selectedSamples.length > 0) {
          return this.selectedSamples.map(s => s.label).join("<br />");
        } else {
          return "ADD";
        }
      },
      variableButtonText() {
        if (this.selectedVariables.length > 0) {
          return this.selectedVariables.map(v => v.mnemonic).join("<br />");
        } else {
          return 'ADD';
        }
      },
      placeButtonText(){
        if(this.selectedPlace != null){
          return this.selectedPlace.label;
        }
        else{
          return "USA";
        }
      },
      subpopButtonText() {
        if (this.selectedSubpopulations.length === 0) {
          return "ADD";
        } else {
          return this.selectedSubpopulations.map(s => {
            return `${s.variable.mnemonic} (Restricted to ${s.selectedCount} of ${s.count} codes)`
          }).join("<br />");
        }

      },
      variableButtonClass() {
        let selected = this.selectedVariables.length > 0;
        return [
          'selection',
          'is-small-mobile',
          {
            'is-primary': selected,
            'is-secondary': !selected
          }
        ];
      },
      sampleButtonClass() {
        let selected = this.selectedSamples.length > 0;
        return [
          'selection',
          'is-small-mobile',
          {
            'is-primary': selected,
            'is-secondary': !selected
          }
        ];
      },
      subpopButtonClass() {
        const selected = this.selectedSubpopulations.length > 0;
        return [
          'selection',
          'is-small-mobile',
          {
            'is-primary': selected,
            'is-secondary': !selected
          }
        ];
      },

      varCountText() {
        return `${this.selectedVariables.length} of 2`
      },

      sampleCountText() {
        return `${this.selectedSamples.length} of 2`
      }
    },

    components: {
      AppRouterButton
    }
  }

</script>

<style lang="scss" scoped>

  .toprow {
    margin-bottom: 5px;
    display: flex;

    .selection-item {
      flex-basis: 0;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      padding: 0 0.2rem 0 0.2rem;

      &:first-child {
        padding-left: .5rem;
      }

      &:last-child {
        padding-right: 0.5rem;
      }
    }
  }

  .bottomrow {
    padding: 0 0.5rem 0.25rem 0.5rem;
  }

  .button.selection {
    width: 100%;
    height: auto;
    line-height: 1.25em;
    white-space: normal;
    padding: 2px 2px;
  }

</style>